import { render, staticRenderFns } from "./IconPresetFranchise.vue?vue&type=template&id=dad95426&scoped=true&"
import script from "./IconPresetFranchise.vue?vue&type=script&lang=js&"
export * from "./IconPresetFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad95426",
  null
  
)

export default component.exports